// TODO: migrate to ts
import dayjs from "dayjs"
import _ from "lodash"

export const processOccupantData = (data = {}, options) => {
  const { pages = [] } = data
  const { multipleLocations = false, periodInDays = 30 } = options || {}

  const currentDate = dayjs()

  return {
    ...data,
    pages: pages.map((page) => {
      let data = page?.data || []

      /**
       * NOTE: `groupMultipleLocations` is a boolean flag
       * to enable/disable the feature to group occupants data by `properties.name.en` if duplicate name store in locations
       */
      if (multipleLocations) {
        data = _(data).groupBy("properties.name.en").value()
      }

      return {
        ...page,
        data: _(data)
          .map((locations) => {
            const record = locations[0] ?? locations

            const hasMultipleLocations = locations.length > 1

            const startDate = dayjs(record.properties?.start_date)
            const isNewShop =
              currentDate.isSameOrAfter(startDate) &&
              currentDate.diff(startDate, "day") <= periodInDays
            const isComingSoon = startDate.isAfter(currentDate)

            return {
              ...record,
              properties: {
                ...record.properties,
                hasMultipleLocations,
                isNewShop,
                isComingSoon,
                startDate,
              },
            }
          })
          .value(),
      }
    }),
  }
}
